/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: alignment.controls.ts
 * Project: mle-client-n
 * Committed last: 2022/1/29 @ 1057
 * ---
 * Description:
 */

/**
 * Rappresenta le azioni che si possono svolgere per allineare una forma
 */
import { Editor }          from '../../../../store/observables/Editor';
import {
  ButtonGroupShapeControl,
  controlGroupBuilder,
  ControlGroupLayouts
}                          from '../../helpers/ControlGroup';
import { ALL_SHAPE_TYPES } from '../../../enums';
import {
  ControlTypes
}                          from '../../../selection-properties';
import {
  HorizontalAlignment,
  VerticalAlignment
}                          from '@revodigital/pamela/lib/configuration/Alignment';
import { Nullable }        from '../../../interfaces';

export const alignmentControls = (editor: Editor) => controlGroupBuilder({
  title: 'Allineamento',
  layout: ControlGroupLayouts.FLEX_ROW,
  controlledShapeTypes: ALL_SHAPE_TYPES,
  shapeControls: [
    new ButtonGroupShapeControl<Nullable<HorizontalAlignment>>({
      label: 'Orizzontale',
      controlType: ControlTypes.BUTTON_GROUP,
      displayMeasureUnit: false,
      observableValue: null,
      setter: value => {
        editor.drawArea().alignCurrentShapeHorizontally(value as HorizontalAlignment);
      }
    }, [ {
      name: HorizontalAlignment.Left,
      value: HorizontalAlignment.Left,
      icon: 'alignment-left'
    }, {
      name: HorizontalAlignment.Center,
      value: HorizontalAlignment.Center,
      icon: 'alignment-vertical-center'
    }, {
      name: HorizontalAlignment.Right,
      value: HorizontalAlignment.Right,
      icon: 'alignment-right',
    } ]),
    new ButtonGroupShapeControl<Nullable<VerticalAlignment>>({
      label: 'Verticale',
      controlType: ControlTypes.BUTTON_GROUP,
      displayMeasureUnit: false,
      observableValue: null,
      setter: value => {
        editor.drawArea().alignCurrentShapeVertically(value as VerticalAlignment);
      }
    }, [ {
      name: 'In basso',
      value: VerticalAlignment.Bottom,
      icon: 'alignment-bottom'
    }, {
      name: 'centro',
      value: VerticalAlignment.Center,
      icon: 'alignment-horizontal-center'
    }, {
      name: 'In alto',
      value: VerticalAlignment.Top,
      icon: 'alignment-top',
    } ]),
  ]
});
